import { FaceRecognitionStatusEnum } from '@goldcast/api/content';
import { timeStringToSeconds, convertSecondsToTimeString } from './timeUtils';
import { roundToNDecimalPlaces } from './mathUtils';
import { ProcessedSpeakerAnalysis } from '../types/speakers-analysis';

export const FULL_FACE_REC_NON_APPLICABLE_STATUSES: FaceRecognitionStatusEnum[] = [
  'NOT_APPLICABLE',
  'UNAVAILABLE',
  'FAILED'
];

export const isFaceRecApplicable = (status: FaceRecognitionStatusEnum | undefined): boolean =>
  !FULL_FACE_REC_NON_APPLICABLE_STATUSES.includes(status!);

export const processSpeakerAnalysis = (
  speakerAnalysis: ProcessedSpeakerAnalysis,
  startTime: number
): ProcessedSpeakerAnalysis => {
  const { time_analysis, times, screenshare_bounds, face_rec_backend } = speakerAnalysis;

  if (face_rec_backend === 'arcface') {
    return speakerAnalysis;
  }

  if (speakerAnalysis.start_offset === startTime) {
    return speakerAnalysis;
  }

  if (!time_analysis || !times || time_analysis.length === 0 || times.length === 0) {
    return {
      ...speakerAnalysis
    };
  }
  const differenceInStartTime = startTime - (speakerAnalysis.start_offset ?? 0);

  const paddedTimes = time_analysis.map(entry =>
    roundToNDecimalPlaces(differenceInStartTime + timeStringToSeconds(entry.time), 4)
  );

  const paddedTimeAnalysis = time_analysis.map((entry, index) => ({
    ...entry,
    time: convertSecondsToTimeString(paddedTimes[index])
  }));

  const paddedScreenShare = screenshare_bounds
    ? screenshare_bounds.map(entry => ({
        ...entry,
        start_time: roundToNDecimalPlaces(differenceInStartTime + entry.start_time, 4),
        end_time: roundToNDecimalPlaces(differenceInStartTime + entry.end_time, 4)
      }))
    : undefined;

  return {
    ...speakerAnalysis,
    times: paddedTimes,
    start_offset: startTime,
    time_analysis: paddedTimeAnalysis,
    ...(paddedScreenShare && { screenshare_bounds: paddedScreenShare })
  };
};
